import JSURL from 'jsurl';
import _filter from 'lodash/filter';
import { intersection } from 'lodash';

function getHashVars() {
    // parse the hash
    const hash = document.location.hash.replace(/^#/, '');
    if (hash.length < 1 || hash === 'li') {
        return {};
    }
    return JSURL.tryParse(hash, {});
}

function getHashVar(key) {
    const vars = getHashVars();
    if (typeof vars[key] !== 'undefined') {
        return vars[key];
    }
    return false;
}

function setHashVar(key, value) {
    const vars = getHashVars();
    if (typeof vars[key] !== 'undefined' && value === null) {
        // unset if passed null for value
        delete vars[key];
    } else {
        vars[key] = value;
    }
    if (Object.keys(vars).length > 0) {
        document.location.hash = `#${JSURL.stringify(vars)}`;
    } else {
        document.location.hash = '';
    }
    // console.log(location.href);
}

function main(salvattore) {
    const lists = document.querySelectorAll('[data-tag-menu-list]');
    lists.forEach((list) => {
        const tags = list.querySelectorAll('[data-tag]');
        const listId = list.dataset.tagMenuList;
        const single = list.dataset.tagMenuStyle === 'single';
        const hashkey = `tags-${listId}`;
        const hashtags = getHashVar(hashkey);
        const label = list.parentNode.querySelector('[data-tag-menu-label]');

        tags.forEach((tag) => {
            // add in the click event
            tag.addEventListener('click', (e) => {
                e.preventDefault();

                // query selector string for which items I can filter
                const targetQuery = tag.dataset.tagTargets;
                // node list of tags that filter the same items
                const siblingTags = document.querySelectorAll(`[data-tag-targets="${targetQuery}"]`);
                // node list of what I can filter
                const targetList = document.querySelectorAll(targetQuery);

                // toggle selected state on this tag
                tag.classList.toggle('-selected');
                if (single) {
                    // un-select all the others (only allow one tag to be selected)
                    tags.forEach((otherTag) => {
                        if (otherTag.dataset.tag !== tag.dataset.tag) {
                            otherTag.classList.remove('-selected');
                        }
                    });
                }

                // update the list
                // get the current selected sibling tags
                const selectedTags = _filter(siblingTags, (el) => (el.classList.contains('-selected')));

                let ids = false;
                if (selectedTags.length) {
                    ids = selectedTags.map((el) => (JSON.parse(el.dataset.tag)));

                    // do the filtering for each item in the list
                    targetList.forEach((item) => {
                        const itemIds = JSON.parse(item.dataset.tagIds);
                        if (intersection(ids, itemIds).length) {
                            item.classList.remove('-hidden');
                            item.setAttribute('hidden', false);
                            item.removeAttribute('hidden');
                        } else {
                            item.classList.add('-hidden');
                            item.setAttribute('hidden', true);
                        }
                    });
                } else {
                    // if no tags are selected, show them all
                    targetList.forEach((item) => {
                        item.classList.remove('-hidden');
                        item.removeAttribute('hidden');
                    });
                }

                // if we have salvattore data-columns, make sure we recreate them
                if (salvattore) {
                    const cardlists = document.querySelectorAll('[data-columns]');
                    if (cardlists.length) {
                        cardlists.forEach((cardlist) => {
                            salvattore.recreateColumns(cardlist);
                        });
                    }
                }

                // hide the menu if we're on mobile
                label.parentNode.classList.remove('-show');

                // if we have a selected tag, update the label (for mobile),
                // or put it back if no selected tag
                if (selectedTags.length === 1) {
                    label.textContent = selectedTags[0].textContent;
                } else {
                    label.textContent = label.dataset.tagMenuLabel;
                }

                // update the hash
                if (ids && ids.length) {
                    setHashVar(`tags-${listId}`, ids);
                } else {
                    setHashVar(`tags-${listId}`, null);
                }
            });
        });

        // do we have tags already in the hash for this list?
        if (hashtags) {
            Object.keys(hashtags).forEach((key) => {
                document.querySelector(`[data-tag="${hashtags[key]}"]`).click();
            });
        }
    });

    // mobile and desktop show/hide list
    const labels = document.querySelectorAll('[data-tag-menu-label]');
    labels.forEach((label) => {
        label.addEventListener('click', () => {
            label.parentNode.classList.toggle('-show');
        });
    });
}

if (document.querySelector('[data-columns]')) {
    import(/* webpackChunkName: "salvattore" */ 'salvattore').then((salvattore) => {
        main(salvattore);
    });
} else {
    main(null);
}
